// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__19WaN","Welcome":"Logo__Welcome__1k00H","Kanban":"Logo__Kanban__26FBc","Blink":"Logo__Blink__2UqYM","typing":"Logo__typing__1ekyH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 274
// module chunks = 0